import { useEffect, useRef, useState } from 'react'
import { SGeneralForms } from 'shj-components'
import { useParams } from 'react-router-dom'
import dayjs from 'dayjs'
import { evaluationRecordDetail } from '@/services/evaluateConfig'

const EvaluateRecordInfo = (props: any) => {
    const formRefs = useRef<any>()
    const params = useParams()
    const id = params?.id || ''
    const [pageData, setPageData] = useState<any>({})
    const [timeConsuming, setTimeConsuming] = useState(0);
    useEffect(() => {
        setPageData(props.pageData)
    }, [props.pageData])
    useEffect(() => {
        setTimeConsuming(props.timeConsuming)
    }, [props.timeConsuming])

    const setPhone = (name, labelFlag) => {
        evaluationRecordDetail(id).then(res => {
            if (res) {
                formRefs?.current?.onFormRef()?.setFieldValue(name, res[name])
                pageData[name] = res[name]
                setPageData({ ...pageData })
            }
        })
    }
    return (

        <SGeneralForms
            ref={formRefs}
            detailsData={pageData}
            isDetail={true}
            configs={[
                {
                    title: '基础信息',
                    titleMode: 'drawer',
                    formItem: [
                        {
                            name: 'code',
                            label: '编号',
                        },
                        {
                            name: 'companyName',
                            label: '分公司',
                        },
                        {
                            name: 'pushConditionsDesc',
                            label: '需求状态',
                            children: <div style={{ color: 'rgb(102, 102, 102)' }}>{pageData?.evaluationConfig?.pushConditionsDesc}</div>
                        },
                        {
                            name: 'demandTypeDesc',
                            label: '需求类型',
                            children: <div style={{ color: 'rgb(102, 102, 102)' }}>{pageData?.demandTypeDesc}</div>
                        },
                        {
                            name: 'customerName',
                            label: '客户名称',
                        },
                        {
                            name: 'customerPhone',
                            label: '联系电话'
                            // children: () => (
                            //     <div style={{ color: 'rgb(153,153,153)' }}>
                            //         <span>{pageData?.customerPhone}</span>
                            //         {authDict['returnMoneyPhone'] ? (
                            //             pageData && pageData?.customerPhone && pageData?.customerPhone.includes('*') ? (
                            //                 <EyeInvisibleOutlined
                            //                     onClick={() => setPhone('customerPhone', true)}
                            //                     style={{ cursor: 'pointer' }}
                            //                 />
                            //             ) : (
                            //                 <EyeOutlined
                            //                     onClick={() => setPhone('customerPhone', false)}
                            //                     style={{ cursor: 'pointer' }}
                            //                 />
                            //             )
                            //         ) : null}
                            //     </div>
                            // ),
                        },
                        {
                            name: 'createdTime',
                            label: '推送时间',
                            children: () => {
                                return (
                                    <div style={{ color: 'rgb(153,153,153)' }}>
                                        {pageData['createdTime']
                                            ? dayjs(pageData['createdTime']).format('YYYY-MM-DD HH:mm:ss')
                                            : '-'}
                                    </div>
                                )
                            },
                        },
                        {
                            name: 'evaluationTime',
                            label: '评价时间',
                            children: () => {
                                return (
                                    <div style={{ color: 'rgb(153,153,153)' }}>
                                        {pageData['evaluationTime']
                                            ? dayjs(pageData['evaluationTime']).format('YYYY-MM-DD HH:mm:ss')
                                            : '-'}
                                    </div>
                                )
                            },
                        },


                        {
                            name: 'timeConsuming',
                            label: '评价耗时',
                            children: () => {
                                return (
                                    <div style={{ color: 'rgb(153,153,153)' }}>
                                        {props.timeConsuming == null ? pageData?.['timeConsuming']?? 0 : timeConsuming }s
                                    </div>
                                )
                            },
                        },
                        {
                          name: 'modifyTime',
                          label: '修改评价时间',
                          children: () => {
                            return (
                              <div style={{ color: 'rgb(153,153,153)' }}>
                                {pageData?.modifyTime
                                  ? dayjs(Number(pageData?.modifyTime)).format('YYYY-MM-DD HH:mm:ss')
                                  : '-'}
                              </div>
                            )
                          },
                        },
                    ],
                },
            ]}
        />
    )
}

export default EvaluateRecordInfo
